import { graphql } from "@/lib/gql/__generated__";

export const Hotel_DesignPage_Query = graphql(`
	query Hotel_DesignPage($hotelID: ID!) {
		hotel(hotelID: $hotelID) {
			id
			name
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
		}
	}
`);
